const config = {
    build_number: '617819',
    build_timestamp: '2026-11-04T18:51:15.915Z',
    build_commit: 'deb62f2143c7fa03a26f229996d1f11df43f3b6a',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
